import Constants from 'config/constants';

export class StoreChain {
	static isMultiChain(storeList, pickupWebsite) {
		if (pickupWebsite === Constants.COOKIE_GOLF_GALAXY) {
			return storeList.filter(store => store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS).length > 0 ?
				storeList.filter(store => store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS) : false;
		} else {
			return storeList.filter(store => store.chain === Constants.CHAIN_GOLF_GALAXY).length > 0 ?
				storeList.filter(store => store.chain === Constants.CHAIN_GOLF_GALAXY) : false;
		}
	}
}
